export const kubevirtDocumentationLink =
  'https://platform9.com/docs/kubevirt/platform9-managed-kubevirt-overview'
export const tutorialsLink = 'https://platform9.com/resources/'
export const vmsLink = 'https://kubevirt.io/user-guide/architecture/#when-to-use-a-virtualmachine'
export const vmisLink =
  'https://kubevirt.io/user-guide/virtual_machines/virtual_machine_instances/#virtual-machines-instances'
